import type {ChangeEvent} from 'react'
import {useMemo} from 'react'

import {getEmptyHash} from '../../../../../../../../../utils/empty'
import {usePipelineId} from '../../../../../../hooks/pipeline'

import {usePipelineExistingJob} from 'src/components/pages/PipelinesPages/EditPipelinePage/EditPipelinePage.hooks'
import {getDraftJobs} from 'src/components/pages/PipelinesPages/EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from 'src/components/pages/PipelinesPages/EditPipelinePage/slices/EditPipelinePage.slices'
import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

function useJobFilesPublication(jobId: string) {
  const dispatch = useAppDispatch()
  const pipelineExistingJob = usePipelineExistingJob(jobId)
  const id = usePipelineId()
  const pipelineJobs = useAppSelector(state => getDraftJobs(state, id)) ?? getEmptyHash()
  const filesPublication = useMemo(
    () => pipelineJobs?.[jobId]?.['files-publication']?.join('\n') ?? '',
    [pipelineJobs, jobId],
  )
  // Task: TCP-22 Rework "Use files..." link on Dependencies block
  // Update all dependencies jobs that have files dependencies
  const updateFilesDependenciesThrottled = (files?: string[]) => {
    for (const key in pipelineJobs) {
      if (key in pipelineJobs) {
        const job = pipelineJobs[key]
        job?.dependencies?.forEach(dependency => {
          const hasDependencyFiles =
            typeof dependency === 'object' && dependency?.[jobId]?.files?.length

          if (hasDependencyFiles) {
            dispatch(
              pipelineDraft.actions.setFilesDependencies({
                id,
                jobId: key,
                dependencyId: jobId,
                files,
              }),
            )
          }
        })
      }
    }
  }
  const handlerFilesPublicationTextAreaChange = ({target}: ChangeEvent<HTMLTextAreaElement>) => {
    const targetValue = target.value
    const files = !targetValue ? undefined : targetValue.split('\n')

    dispatch(
      pipelineDraft.actions.setFilesPublication({
        id,
        jobId,
        files,
      }),
    )

    updateFilesDependenciesThrottled(files)
  }
  const savedFilesPublication = useMemo(
    () => pipelineExistingJob?.['files-publication'] ?? [],
    [pipelineExistingJob],
  )
  const isUnsaved = pipelineExistingJob && savedFilesPublication?.join('\n') !== filesPublication

  return {
    handlerFilesPublicationTextAreaChange,
    filesPublication,
    isUnsaved,
  }
}

export default useJobFilesPublication
